(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[20,966],{

/***/ "+wNj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectWithoutPropertiesLoose; });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),

/***/ "54uq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_AVAILABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return API_VALIDATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_ACTIVATED; });
/* unused harmony export API_EDITABLE */
/* unused harmony export API_UNAVAILABLE */
/* unused harmony export API_NOTYET */
/* unused harmony export API_UNEDITABLE */
/* unused harmony export API_OPTION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_RESORT_ONLY; });
/* unused harmony export API_UPSELL_AVAILABLE */
/* unused harmony export API_RESORT_ONLY_FORM_SENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return API_DONE; });
var API_AVAILABLE = 'AVAILABLE';
var API_VALIDATED = 'VALIDATED';
var API_ACTIVATED = 'ACTIVATED';
var API_EDITABLE = 'EDITABLE';
var API_UNAVAILABLE = 'UNAVAILABLE';
var API_NOTYET = 'NOT_YET';
var API_UNEDITABLE = 'UNEDITABLE';
var API_OPTION = 'OPTION';
var API_RESORT_ONLY = 'RESORT_ONLY';
var API_RESORT_ONLY_FORM_SENT = 'RESORT_ONLY_FORM_SENT';
var API_UPSELL_AVAILABLE = 'UPSELL_AVAILABLE';
var API_DONE = 'DONE';


/***/ }),

/***/ "8K1b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _inherits; });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("XcBm");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(subClass, superClass);
}

/***/ }),

/***/ "9fIP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _classCallCheck; });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "HbGN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectWithoutProperties; });
/* harmony import */ var _objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("+wNj");

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(_objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),

/***/ "K/z8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _possibleConstructorReturn; });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4wDe");
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("pWxA");


function _possibleConstructorReturn(self, call) {
  if (call && (Object(_typeof_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return Object(_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(self);
}

/***/ }),

/***/ "LNcM":
/***/ (function(module, exports) {

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */

(function(window, document) {
'use strict';


// Exits early if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.
if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

  // Minimal polyfill for Edge 15's lack of `isIntersecting`
  // See: https://github.com/w3c/IntersectionObserver/issues/211
  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
    Object.defineProperty(window.IntersectionObserverEntry.prototype,
      'isIntersecting', {
      get: function () {
        return this.intersectionRatio > 0;
      }
    });
  }
  return;
}


/**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */
var registry = [];


/**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */
function IntersectionObserverEntry(entry) {
  this.time = entry.time;
  this.target = entry.target;
  this.rootBounds = entry.rootBounds;
  this.boundingClientRect = entry.boundingClientRect;
  this.intersectionRect = entry.intersectionRect || getEmptyRect();
  this.isIntersecting = !!entry.intersectionRect;

  // Calculates the intersection ratio.
  var targetRect = this.boundingClientRect;
  var targetArea = targetRect.width * targetRect.height;
  var intersectionRect = this.intersectionRect;
  var intersectionArea = intersectionRect.width * intersectionRect.height;

  // Sets intersection ratio.
  if (targetArea) {
    // Round the intersection ratio to avoid floating point math issues:
    // https://github.com/w3c/IntersectionObserver/issues/324
    this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
  } else {
    // If area is zero and is intersecting, sets to 1, otherwise to 0
    this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
}


/**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */
function IntersectionObserver(callback, opt_options) {

  var options = opt_options || {};

  if (typeof callback != 'function') {
    throw new Error('callback must be a function');
  }

  if (options.root && options.root.nodeType != 1) {
    throw new Error('root must be an Element');
  }

  // Binds and throttles `this._checkForIntersections`.
  this._checkForIntersections = throttle(
      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

  // Private properties.
  this._callback = callback;
  this._observationTargets = [];
  this._queuedEntries = [];
  this._rootMarginValues = this._parseRootMargin(options.rootMargin);

  // Public properties.
  this.thresholds = this._initThresholds(options.threshold);
  this.root = options.root || null;
  this.rootMargin = this._rootMarginValues.map(function(margin) {
    return margin.value + margin.unit;
  }).join(' ');
}


/**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */
IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


/**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */
IntersectionObserver.prototype.POLL_INTERVAL = null;

/**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */
IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;


/**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.observe = function(target) {
  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
    return item.element == target;
  });

  if (isTargetAlreadyObserved) {
    return;
  }

  if (!(target && target.nodeType == 1)) {
    throw new Error('target must be an Element');
  }

  this._registerInstance();
  this._observationTargets.push({element: target, entry: null});
  this._monitorIntersections();
  this._checkForIntersections();
};


/**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.unobserve = function(target) {
  this._observationTargets =
      this._observationTargets.filter(function(item) {

    return item.element != target;
  });
  if (!this._observationTargets.length) {
    this._unmonitorIntersections();
    this._unregisterInstance();
  }
};


/**
 * Stops observing all target elements for intersection changes.
 */
IntersectionObserver.prototype.disconnect = function() {
  this._observationTargets = [];
  this._unmonitorIntersections();
  this._unregisterInstance();
};


/**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */
IntersectionObserver.prototype.takeRecords = function() {
  var records = this._queuedEntries.slice();
  this._queuedEntries = [];
  return records;
};


/**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */
IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
  var threshold = opt_threshold || [0];
  if (!Array.isArray(threshold)) threshold = [threshold];

  return threshold.sort().filter(function(t, i, a) {
    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
      throw new Error('threshold must be a number between 0 and 1 inclusively');
    }
    return t !== a[i - 1];
  });
};


/**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */
IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
  var marginString = opt_rootMargin || '0px';
  var margins = marginString.split(/\s+/).map(function(margin) {
    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
    if (!parts) {
      throw new Error('rootMargin must be specified in pixels or percent');
    }
    return {value: parseFloat(parts[1]), unit: parts[2]};
  });

  // Handles shorthand.
  margins[1] = margins[1] || margins[0];
  margins[2] = margins[2] || margins[0];
  margins[3] = margins[3] || margins[1];

  return margins;
};


/**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @private
 */
IntersectionObserver.prototype._monitorIntersections = function() {
  if (!this._monitoringIntersections) {
    this._monitoringIntersections = true;

    // If a poll interval is set, use polling instead of listening to
    // resize and scroll events or DOM mutations.
    if (this.POLL_INTERVAL) {
      this._monitoringInterval = setInterval(
          this._checkForIntersections, this.POLL_INTERVAL);
    }
    else {
      addEvent(window, 'resize', this._checkForIntersections, true);
      addEvent(document, 'scroll', this._checkForIntersections, true);

      if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
        this._domObserver = new MutationObserver(this._checkForIntersections);
        this._domObserver.observe(document, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @private
 */
IntersectionObserver.prototype._unmonitorIntersections = function() {
  if (this._monitoringIntersections) {
    this._monitoringIntersections = false;

    clearInterval(this._monitoringInterval);
    this._monitoringInterval = null;

    removeEvent(window, 'resize', this._checkForIntersections, true);
    removeEvent(document, 'scroll', this._checkForIntersections, true);

    if (this._domObserver) {
      this._domObserver.disconnect();
      this._domObserver = null;
    }
  }
};


/**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */
IntersectionObserver.prototype._checkForIntersections = function() {
  var rootIsInDom = this._rootIsInDom();
  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

  this._observationTargets.forEach(function(item) {
    var target = item.element;
    var targetRect = getBoundingClientRect(target);
    var rootContainsTarget = this._rootContainsTarget(target);
    var oldEntry = item.entry;
    var intersectionRect = rootIsInDom && rootContainsTarget &&
        this._computeTargetAndRootIntersection(target, rootRect);

    var newEntry = item.entry = new IntersectionObserverEntry({
      time: now(),
      target: target,
      boundingClientRect: targetRect,
      rootBounds: rootRect,
      intersectionRect: intersectionRect
    });

    if (!oldEntry) {
      this._queuedEntries.push(newEntry);
    } else if (rootIsInDom && rootContainsTarget) {
      // If the new entry intersection ratio has crossed any of the
      // thresholds, add a new entry.
      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
        this._queuedEntries.push(newEntry);
      }
    } else {
      // If the root is not in the DOM or target is not contained within
      // root but the previous entry for this target had an intersection,
      // add a new record indicating removal.
      if (oldEntry && oldEntry.isIntersecting) {
        this._queuedEntries.push(newEntry);
      }
    }
  }, this);

  if (this._queuedEntries.length) {
    this._callback(this.takeRecords(), this);
  }
};


/**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */
IntersectionObserver.prototype._computeTargetAndRootIntersection =
    function(target, rootRect) {

  // If the element isn't displayed, an intersection can't happen.
  if (window.getComputedStyle(target).display == 'none') return;

  var targetRect = getBoundingClientRect(target);
  var intersectionRect = targetRect;
  var parent = getParentNode(target);
  var atRoot = false;

  while (!atRoot) {
    var parentRect = null;
    var parentComputedStyle = parent.nodeType == 1 ?
        window.getComputedStyle(parent) : {};

    // If the parent isn't displayed, an intersection can't happen.
    if (parentComputedStyle.display == 'none') return;

    if (parent == this.root || parent == document) {
      atRoot = true;
      parentRect = rootRect;
    } else {
      // If the element has a non-visible overflow, and it's not the <body>
      // or <html> element, update the intersection rect.
      // Note: <body> and <html> cannot be clipped to a rect that's not also
      // the document rect, so no need to compute a new intersection.
      if (parent != document.body &&
          parent != document.documentElement &&
          parentComputedStyle.overflow != 'visible') {
        parentRect = getBoundingClientRect(parent);
      }
    }

    // If either of the above conditionals set a new parentRect,
    // calculate new intersection data.
    if (parentRect) {
      intersectionRect = computeRectIntersection(parentRect, intersectionRect);

      if (!intersectionRect) break;
    }
    parent = getParentNode(parent);
  }
  return intersectionRect;
};


/**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {Object} The expanded root rect.
 * @private
 */
IntersectionObserver.prototype._getRootRect = function() {
  var rootRect;
  if (this.root) {
    rootRect = getBoundingClientRect(this.root);
  } else {
    // Use <html>/<body> instead of window since scroll bars affect size.
    var html = document.documentElement;
    var body = document.body;
    rootRect = {
      top: 0,
      left: 0,
      right: html.clientWidth || body.clientWidth,
      width: html.clientWidth || body.clientWidth,
      bottom: html.clientHeight || body.clientHeight,
      height: html.clientHeight || body.clientHeight
    };
  }
  return this._expandRectByRootMargin(rootRect);
};


/**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {Object} rect The rect object to expand.
 * @return {Object} The expanded rect.
 * @private
 */
IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
  var margins = this._rootMarginValues.map(function(margin, i) {
    return margin.unit == 'px' ? margin.value :
        margin.value * (i % 2 ? rect.width : rect.height) / 100;
  });
  var newRect = {
    top: rect.top - margins[0],
    right: rect.right + margins[1],
    bottom: rect.bottom + margins[2],
    left: rect.left - margins[3]
  };
  newRect.width = newRect.right - newRect.left;
  newRect.height = newRect.bottom - newRect.top;

  return newRect;
};


/**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */
IntersectionObserver.prototype._hasCrossedThreshold =
    function(oldEntry, newEntry) {

  // To make comparing easier, an entry that has a ratio of 0
  // but does not actually intersect is given a value of -1
  var oldRatio = oldEntry && oldEntry.isIntersecting ?
      oldEntry.intersectionRatio || 0 : -1;
  var newRatio = newEntry.isIntersecting ?
      newEntry.intersectionRatio || 0 : -1;

  // Ignore unchanged ratios
  if (oldRatio === newRatio) return;

  for (var i = 0; i < this.thresholds.length; i++) {
    var threshold = this.thresholds[i];

    // Return true if an entry matches a threshold or if the new ratio
    // and the old ratio are on the opposite sides of a threshold.
    if (threshold == oldRatio || threshold == newRatio ||
        threshold < oldRatio !== threshold < newRatio) {
      return true;
    }
  }
};


/**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */
IntersectionObserver.prototype._rootIsInDom = function() {
  return !this.root || containsDeep(document, this.root);
};


/**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */
IntersectionObserver.prototype._rootContainsTarget = function(target) {
  return containsDeep(this.root || document, target);
};


/**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */
IntersectionObserver.prototype._registerInstance = function() {
  if (registry.indexOf(this) < 0) {
    registry.push(this);
  }
};


/**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */
IntersectionObserver.prototype._unregisterInstance = function() {
  var index = registry.indexOf(this);
  if (index != -1) registry.splice(index, 1);
};


/**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */
function now() {
  return window.performance && performance.now && performance.now();
}


/**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */
function throttle(fn, timeout) {
  var timer = null;
  return function () {
    if (!timer) {
      timer = setTimeout(function() {
        fn();
        timer = null;
      }, timeout);
    }
  };
}


/**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */
function addEvent(node, event, fn, opt_useCapture) {
  if (typeof node.addEventListener == 'function') {
    node.addEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.attachEvent == 'function') {
    node.attachEvent('on' + event, fn);
  }
}


/**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */
function removeEvent(node, event, fn, opt_useCapture) {
  if (typeof node.removeEventListener == 'function') {
    node.removeEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.detatchEvent == 'function') {
    node.detatchEvent('on' + event, fn);
  }
}


/**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object} The intersection rect or undefined if no intersection
 *     is found.
 */
function computeRectIntersection(rect1, rect2) {
  var top = Math.max(rect1.top, rect2.top);
  var bottom = Math.min(rect1.bottom, rect2.bottom);
  var left = Math.max(rect1.left, rect2.left);
  var right = Math.min(rect1.right, rect2.right);
  var width = right - left;
  var height = bottom - top;

  return (width >= 0 && height >= 0) && {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: width,
    height: height
  };
}


/**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {Object} The (possibly shimmed) rect of the element.
 */
function getBoundingClientRect(el) {
  var rect;

  try {
    rect = el.getBoundingClientRect();
  } catch (err) {
    // Ignore Windows 7 IE11 "Unspecified error"
    // https://github.com/w3c/IntersectionObserver/pull/205
  }

  if (!rect) return getEmptyRect();

  // Older IE
  if (!(rect.width && rect.height)) {
    rect = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.right - rect.left,
      height: rect.bottom - rect.top
    };
  }
  return rect;
}


/**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {Object} The empty rect.
 */
function getEmptyRect() {
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0
  };
}

/**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */
function containsDeep(parent, child) {
  var node = child;
  while (node) {
    if (node == parent) return true;

    node = getParentNode(node);
  }
  return false;
}


/**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */
function getParentNode(node) {
  var parent = node.parentNode;

  if (parent && parent.nodeType == 11 && parent.host) {
    // If the parent is a shadow root, return the host element.
    return parent.host;
  }
  return parent;
}


// Exposes the constructors globally.
window.IntersectionObserver = IntersectionObserver;
window.IntersectionObserverEntry = IntersectionObserverEntry;

}(window, document));


/***/ }),

/***/ "MMYH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _createClass; });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("DAgO");

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, Object(_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ "UXOF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ NavTag_NavTag; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/nav-tag/NavTag.themes.js




var NavTag_themes_themes = function themes(_ref) {
  var _classnames, _classnames2;

  var _ref$colorActive = _ref.colorActive,
      colorActive = _ref$colorActive === void 0 ? colors["a" /* COLORS */].LIGHT_SAND : _ref$colorActive,
      _ref$colorUnactive = _ref.colorUnactive,
      colorUnactive = _ref$colorUnactive === void 0 ? colors["a" /* COLORS */].SAND : _ref$colorUnactive,
      isActive = _ref.isActive;
  return {
    "default": {
      thRoot: Object(classnames_utils["a" /* classnames */])('block border font-bold items-stretch px-20 py-10 rounded-pill text-12 text-black text-sans transition-colors duration-250 ease-in whitespace-nowrap', (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, "bg-".concat(colorActive, " border-").concat(colorActive), isActive), Object(defineProperty["a" /* default */])(_classnames, "bg-transparent border-".concat(colorUnactive, " hocus:bg-").concat(colorActive, " hocus:border-").concat(colorActive), !isActive), _classnames))
    },
    reverse: {
      thRoot: Object(classnames_utils["a" /* classnames */])('block border font-bold items-stretch px-20 py-10 rounded-pill text-12 text-sans transition-colors duration-250 ease-in whitespace-nowrap', (_classnames2 = {}, Object(defineProperty["a" /* default */])(_classnames2, "bg-".concat(colorActive, " border-").concat(colorActive, " text-").concat(colors["c" /* COMPLEMENTARY_COLORS */][colorActive]), isActive), Object(defineProperty["a" /* default */])(_classnames2, "bg-".concat(colorUnactive, " border-").concat(colorUnactive, " text-").concat(colors["c" /* COMPLEMENTARY_COLORS */][colorUnactive], " hocus:bg-").concat(colorActive, " hocus:border-").concat(colorActive, " hocus:text-").concat(colors["c" /* COMPLEMENTARY_COLORS */][colorActive]), !isActive), _classnames2))
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/nav-tag/NavTag.jsx




var __jsx = react_default.a.createElement;




var NavTag_NavTag = function NavTag(_ref) {
  var children = _ref.children,
      className = _ref.className,
      colorActive = _ref.colorActive,
      colorUnactive = _ref.colorUnactive,
      href = _ref.href,
      isActive = _ref.isActive,
      _onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      _ref$trackingData = _ref.trackingData,
      trackingData = _ref$trackingData === void 0 ? {} : _ref$trackingData,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["children", "className", "colorActive", "colorUnactive", "href", "isActive", "onClick", "theme", "trackingData"]);

  var tracker = Object(useTracking["a" /* useTracking */])();
  var track = !isEmpty_default()(trackingData) && _onClick ? function () {
    return tracker(trackingData);
  } : noop_default.a;

  if (!react["Children"].count(children)) {
    return null;
  }

  var TagName = 'div';

  if (href) {
    TagName = 'a';
  } else if (_onClick) {
    TagName = 'button';
  }

  var thRoot = NavTag_themes_themes({
    colorActive: colorActive,
    colorUnactive: colorUnactive,
    isActive: isActive
  })[theme].thRoot;
  return __jsx(TagName, Object(esm_extends["a" /* default */])({
    "data-testid": "Tag" // $FlowFixMe

  }, rest, {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    onClick: function onClick(e) {
      _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
      track();
    },
    href: href
  }, _onClick ? {
    type: href ? 'link' : 'button'
  } : null), children);
};

/***/ }),

/***/ "XcBm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _setPrototypeOf; });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ "aPQG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sendErrorToSentry; });
/* unused harmony export shouldIgnore */
/* unused harmony export processError */
/* unused harmony export handleBrowserError */
/* unused harmony export handlePromiseError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleComponentError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return start; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("m0zD");
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_logger__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _errors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("wNDy");









/* eslint-env browser */





var sanitize = function sanitize() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return s && s.trim().toLowerCase();
};

var sendErrorToSentry = function sendErrorToSentry(_ref) {
  var error = _ref.error,
      _ref$errorInfo = _ref.errorInfo,
      errorInfo = _ref$errorInfo === void 0 ? {} : _ref$errorInfo;

  if ( true && _config__WEBPACK_IMPORTED_MODULE_9___default.a.get('clientError.sentry.enabled')) {
    var _window$Sentry;

    (_window$Sentry = window.Sentry) === null || _window$Sentry === void 0 ? void 0 : _window$Sentry.withScope(function (scope) {
      var _window$Sentry2;

      Object.keys(errorInfo).forEach(function (key) {
        scope.setExtra(key, errorInfo[key]);
      });
      (_window$Sentry2 = window.Sentry) === null || _window$Sentry2 === void 0 ? void 0 : _window$Sentry2.captureException(error);
    });
  }
};
var shouldIgnore = function shouldIgnore(error) {
  var errorMessagesToIgnore = [].concat(_config__WEBPACK_IMPORTED_MODULE_9___default.a.get('clientError.ignore.descriptions'));
  var errorMessage = sanitize(error.message);
  var errorStack = sanitize(error.stack);
  return errorMessagesToIgnore.some(function (messageToIgnore) {
    var msg = sanitize(messageToIgnore);
    var isIgnored = !!msg && (!!errorMessage.includes(msg) || !!errorStack.includes(msg));
    return isIgnored;
  });
};
var processError = function processError(_ref2) {
  var error = _ref2.error,
      errorInfo = _ref2.errorInfo;
  _logger__WEBPACK_IMPORTED_MODULE_10___default.a.error({
    err: error,
    info: errorInfo
  });

  if (!shouldIgnore(error)) {
    sendErrorToSentry({
      error: error,
      errorInfo: errorInfo
    });
  }

  return error;
}; // eslint-disable-next-line max-params

var handleBrowserError = function handleBrowserError(message, file, line, col, error) {
  return processError({
    error: error || new _errors__WEBPACK_IMPORTED_MODULE_11__[/* ClientSideError */ "c"]({
      name: 'Unknown error name',
      message: message || 'Unknown error message',
      stack: 'Unknown stack'
    }),
    errorInfo: {
      message: message,
      file: file,
      line: line,
      col: col
    }
  });
};
var handlePromiseError = function handlePromiseError(domCustomEvent) {
  return processError({
    error: lodash_get__WEBPACK_IMPORTED_MODULE_8___default()(domCustomEvent, 'detail.reason', lodash_get__WEBPACK_IMPORTED_MODULE_8___default()(domCustomEvent, 'reason', new _errors__WEBPACK_IMPORTED_MODULE_11__[/* ClientSideError */ "c"]({
      name: 'Unknown rejected promise name',
      message: 'Unknown rejected promise message',
      stack: ['Unknown stack']
    })))
  });
};
var handleComponentError = function handleComponentError(error, errorInfo) {
  return processError({
    error: error || new _errors__WEBPACK_IMPORTED_MODULE_11__[/* ClientSideError */ "c"]({
      name: 'Unknown component error name',
      message: 'Unknown component error message',
      stack: ['Unknown stack']
    }),
    errorInfo: errorInfo
  });
};
var start = function start() {
  window.onerror = handleBrowserError;
  window.addEventListener('unhandledrejection', handlePromiseError);
  window.addEventListener('rejectionhandled', handlePromiseError);
};

/***/ }),

/***/ "bGCG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ getProductUrlFromDestinationLine; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ Product_mapper_getProductProps; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ Product_mapper_getProductPriceInfoProps; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ setProductHref; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ Product_mapper_updateProductUrl; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Product_mapper_createProductUrlWithParams; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ updateProduct; });

// UNUSED EXPORTS: getProductTags, getProductOfferDiscountProps, getProductChildcareAvailabilitiesProps, getProductComparisonProps, getProductFlagProps, getProductHeaderProps, getProductPriceProps, getProductThumbnailProps

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// CONCATENATED MODULE: ./src/client/components/widgets/products-comparison/ProductsComparisonUtils.js



function getAggregateDiscount(product) {
  var proposals = get_default()(product, 'proposals.proposals', []);

  var selectedProposal = proposals.find(function (proposal) {
    return get_default()(proposal, 'selected', true);
  });
  return get_default()(selectedProposal, 'price.aggregateDiscount', null);
}


// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/uri/constants.js
var constants = __webpack_require__("Sj1w");

// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// CONCATENATED MODULE: ./src/client/components/widgets/product/Product.mapper.js






















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}












var OPENING_STATUS = dist["constants"].OPENING_STATUS;
var DEFAULT_COMPARISON = {
  isDisabled: false,
  isSelected: false
};

var getSubTitle = function getSubTitle(product) {
  var _product$destination;

  if (product.isCruise) {
    return product.timingDescription;
  }

  return ((_product$destination = product.destination) === null || _product$destination === void 0 ? void 0 : _product$destination.country) || '';
};

var Product_mapper_getUrl = function getUrl(href, termsAndConditions) {
  var _termsAndConditions$d;

  var queryParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var departureDate = "".concat((termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.departureDate) || '');
  var url = new URI_default.a(href).setQuery({
    locale: queryParams === null || queryParams === void 0 ? void 0 : queryParams.locale,
    departure_city: termsAndConditions === null || termsAndConditions === void 0 ? void 0 : (_termsAndConditions$d = termsAndConditions.departureCity) === null || _termsAndConditions$d === void 0 ? void 0 : _termsAndConditions$d.value,
    duration: termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.duration,
    date: departureDate !== 'null' && departureDate ? Object(apiDate["g" /* formatApiDate */])(departureDate, constants["f" /* QUERY_DATE_FORMAT */]) : undefined
  });
  return url.toString();
};

var getProductUrl = function getProductUrl(props) {
  var _props$product$price;

  var isMice = !!props.product.mice;

  if (!props.contextualizeUrl) {
    return "".concat(isMice ? '/me' : '').concat(props.product.href);
  }

  var url = Product_mapper_getUrl(props.product.href, ((_props$product$price = props.product.price) === null || _props$product$price === void 0 ? void 0 : _props$product$price.termsAndConditions) || {});
  return "".concat(isMice ? '/me' : '').concat(url);
};

var getProductUrlFromDestinationLine = function getProductUrlFromDestinationLine(price, queryParams) {
  return Product_mapper_getUrl(price.productHref || '', price.termsAndConditions, queryParams);
};

var getProductHeaderProps = function getProductHeaderProps(props) {
  var product = props.product;
  var link = {
    url: getProductUrl(props)
  };
  var heading = {
    title: product.name,
    subtitle: getSubTitle(product)
  };
  return {
    heading: heading,
    link: link
  };
};

var Product_mapper_getProductComparisonProps = function getProductComparisonProps(_ref) {
  var _config$faceting;

  var _ref$comparison = _ref.comparison,
      comparison = _ref$comparison === void 0 ? DEFAULT_COMPARISON : _ref$comparison,
      config = _ref.config,
      product = _ref.product;

  var _ref2 = (config === null || config === void 0 ? void 0 : (_config$faceting = config.faceting) === null || _config$faceting === void 0 ? void 0 : _config$faceting.compare) || {},
      selected = _ref2.selected,
      selectResort = _ref2.selectResort,
      unavailableThumbnail = _ref2.unavailableThumbnail;

  var status = product_utils["b" /* IS_ENABLED */];

  if (comparison.isDisabled) {
    status = product_utils["a" /* IS_DISABLED */];
  } else if (comparison.isSelected) {
    status = product_utils["c" /* IS_SELECTED */];
  }

  var label = comparison.isSelected ? selected : selectResort;

  var _ref3 = product || {},
      isCruise = _ref3.isCruise,
      isTour = _ref3.isTour;

  return {
    status: status,
    label: label,
    isEligible: !isTour && !isCruise,
    eligibilityLabel: unavailableThumbnail
  };
};

var Product_mapper_getProductPriceProps = function getProductPriceProps(_ref4) {
  var _config$price;

  var config = _ref4.config,
      product = _ref4.product,
      _ref4$offer = _ref4.offer,
      offer = _ref4$offer === void 0 ? {} : _ref4$offer;
  var color = product.isJoyview ? colors["a" /* COLORS */].BLUE_WAVE : colors["a" /* COLORS */].SIENNA; // $FlowFixMe

  return _objectSpread(_objectSpread({
    style: {
      color: offer.color
    },
    color: offer.color || color
  }, (config === null || config === void 0 ? void 0 : (_config$price = config.price) === null || _config$price === void 0 ? void 0 : _config$price.format) || {}), product.price || product.mice || {});
};

var getChildCareAgeInMonths = function getChildCareAgeInMonths(_ref5) {
  var _product$childcareDet;

  var product = _ref5.product;

  if ((_product$childcareDet = product.childcareDetails) === null || _product$childcareDet === void 0 ? void 0 : _product$childcareDet.length) {
    return product.childcareDetails.map(function (_ref6) {
      var ageInMonths = _ref6.ageInMonths;
      return {
        ageInMonthsMin: ageInMonths.min,
        ageInMonthsMax: ageInMonths.max
      };
    });
  }
};

var Product_mapper_getProductChildcareAvailabilitiesProps = function getProductChildcareAvailabilitiesProps(_ref7) {
  var _config$faceting2;

  var config = _ref7.config,
      product = _ref7.product;

  var _ref8 = (config === null || config === void 0 ? void 0 : (_config$faceting2 = config.faceting) === null || _config$faceting2 === void 0 ? void 0 : _config$faceting2.availabilities) || {},
      monthsLabel = _ref8.months,
      yearsLabel = _ref8.years,
      yearLabel = _ref8.year,
      availableLabel = _ref8.available,
      unknownLabel = _ref8.unknown,
      unavailableLabel = _ref8.unavailable,
      urgentizationSingular = _ref8.urgentizationSingular,
      urgentizationPlural = _ref8.urgentizationPlural,
      childcareLabel = _ref8.childcare;

  var sortedChildcareAvailabilities = (product.childcareAvailabilities || []).sort(function (a, b) {
    return a.ageMin - b.ageMin;
  });

  var _sortedChildcareAvail = sortedChildcareAvailabilities,
      _sortedChildcareAvail2 = Object(slicedToArray["a" /* default */])(_sortedChildcareAvail, 2),
      _sortedChildcareAvail3 = _sortedChildcareAvail2[0],
      first = _sortedChildcareAvail3 === void 0 ? {} : _sortedChildcareAvail3,
      _sortedChildcareAvail4 = _sortedChildcareAvail2[1],
      second = _sortedChildcareAvail4 === void 0 ? {} : _sortedChildcareAvail4;

  var hasChildBetween4And23Months = first.ageMin === 4 || first.ageMax === 23;
  var hasOnlyBetween4And13Months = first.ageMin === 4 && second.ageMax !== 23;
  var hasOnlyBetween14And23Months = first.ageMax === 23;

  if (hasOnlyBetween4And13Months) {
    first.ageMax = 23;
  } else if (hasOnlyBetween14And23Months) {
    first.ageMin = 4;
  } else if (hasChildBetween4And23Months) {
    var stock = first.remainingStock === null && second.remainingStock === null ? null : (first.remainingStock || 0) + (second.remainingStock || 0);
    var availability = 'UNKNOWN';

    if (stock === 0) {
      availability = 'UNAVAILABLE';
    } else if (stock) {
      availability = stock <= 10 ? 'PARTIAL' : 'AVAILABLE';
    }

    sortedChildcareAvailabilities = [_objectSpread(_objectSpread({}, second), {}, {
      remainingStock: stock,
      ageMin: 4,
      ageMax: 23,
      availability: availability
    })].concat(Object(toConsumableArray["a" /* default */])(sortedChildcareAvailabilities.slice(2)));
  }

  return {
    items: sortedChildcareAvailabilities,
    monthsLabel: monthsLabel,
    yearsLabel: yearsLabel,
    yearLabel: yearLabel,
    availableLabel: availableLabel,
    unavailableLabel: unavailableLabel,
    unknownLabel: unknownLabel,
    remainingLabel: {
      n: urgentizationPlural,
      _1: urgentizationSingular
    },
    childcareLabel: childcareLabel
  };
};

var Product_mapper_getProductPriceInfoProps = function getProductPriceInfoProps(_ref9) {
  var _config$resort, _config$resort$starti, _product$price, _product$price$termsA, _product$price2, _product$price2$terms, _product$price3, _product$price3$terms, _product$price4, _product$price4$terms, _product$price4$terms2, _product$price5, _product$price5$terms, _product$price5$terms2, _product$price6, _product$price6$terms, _product$price7, _product$mice;

  var config = _ref9.config,
      product = _ref9.product;
  var startDate = '';
  var endDate = '';
  var dateFormat = (config === null || config === void 0 ? void 0 : (_config$resort = config.resort) === null || _config$resort === void 0 ? void 0 : (_config$resort$starti = _config$resort.startingPrice) === null || _config$resort$starti === void 0 ? void 0 : _config$resort$starti.dateFormat) || Object(i18n["h" /* t */])('resort.startingPrice.dateFormat');
  startDate = moment_default()(product === null || product === void 0 ? void 0 : (_product$price = product.price) === null || _product$price === void 0 ? void 0 : (_product$price$termsA = _product$price.termsAndConditions) === null || _product$price$termsA === void 0 ? void 0 : _product$price$termsA.departureDate, apiDate["a" /* API_DATE_FORMAT */]).format(dateFormat);
  endDate = moment_default()(product === null || product === void 0 ? void 0 : (_product$price2 = product.price) === null || _product$price2 === void 0 ? void 0 : (_product$price2$terms = _product$price2.termsAndConditions) === null || _product$price2$terms === void 0 ? void 0 : _product$price2$terms.departureDate, apiDate["a" /* API_DATE_FORMAT */]).add({
    days: ((_product$price3 = product.price) === null || _product$price3 === void 0 ? void 0 : (_product$price3$terms = _product$price3.termsAndConditions) === null || _product$price3$terms === void 0 ? void 0 : _product$price3$terms.duration) || 0
  }).format(dateFormat);
  return {
    city: (product === null || product === void 0 ? void 0 : (_product$price4 = product.price) === null || _product$price4 === void 0 ? void 0 : (_product$price4$terms = _product$price4.termsAndConditions) === null || _product$price4$terms === void 0 ? void 0 : (_product$price4$terms2 = _product$price4$terms.departureCity) === null || _product$price4$terms2 === void 0 ? void 0 : _product$price4$terms2.name) || '',
    endDate: endDate,
    hasTransport: !!(product === null || product === void 0 ? void 0 : (_product$price5 = product.price) === null || _product$price5 === void 0 ? void 0 : (_product$price5$terms = _product$price5.termsAndConditions) === null || _product$price5$terms === void 0 ? void 0 : (_product$price5$terms2 = _product$price5$terms.departureCity) === null || _product$price5$terms2 === void 0 ? void 0 : _product$price5$terms2.value),
    isCruise: product.isCruise,
    isJoyview: product.isJoyview,
    isTour: product.isTour,
    rate: product === null || product === void 0 ? void 0 : (_product$price6 = product.price) === null || _product$price6 === void 0 ? void 0 : (_product$price6$terms = _product$price6.termsAndConditions) === null || _product$price6$terms === void 0 ? void 0 : _product$price6$terms.offerId,
    startDate: startDate,
    transportIcon: product.transportType,
    unit: ((_product$price7 = product.price) === null || _product$price7 === void 0 ? void 0 : _product$price7.unit) || ((_product$mice = product.mice) === null || _product$mice === void 0 ? void 0 : _product$mice.unit) || ''
  };
};

var Product_mapper_getTopTags = function getTopTags(_ref10) {
  var _product$price8, _product$price8$terms, _product$price8$terms2;

  var hasTransport = _ref10.hasTransport,
      product = _ref10.product;
  var openingStatus = product.openingStatus,
      tags = product.tags;
  var hasDepartureCity = Boolean(product === null || product === void 0 ? void 0 : (_product$price8 = product.price) === null || _product$price8 === void 0 ? void 0 : (_product$price8$terms = _product$price8.termsAndConditions) === null || _product$price8$terms === void 0 ? void 0 : (_product$price8$terms2 = _product$price8$terms.departureCity) === null || _product$price8$terms2 === void 0 ? void 0 : _product$price8$terms2.value);
  var isOpeningSoon = openingStatus === OPENING_STATUS.OPENING_SOON;
  var priorityTagslength = hasDepartureCity + isOpeningSoon + !!product.seasonTrad;

  var productTopTags = Object(toConsumableArray["a" /* default */])((tags || []).slice(0, 3 - priorityTagslength).map(function (tag, i) {
    return {
      dataTestId: "ProductThumbnail-tag-".concat(i),
      label: tag.title,
      style: {
        backgroundColor: tag.backgroundColor,
        borderColor: tag.backgroundColor,
        color: tag.textColor
      }
    };
  }));

  if (product.seasonTrad) {
    productTopTags.push({
      className: 'text-white border-turquoise bg-turquoise',
      dataTestId: 'ProductThumbnail-seasonBadge',
      label: product.seasonTrad
    });
  }

  if (hasDepartureCity || hasTransport) {
    productTopTags.push({
      dataTestId: 'ProductThumbnail-transport',
      iconName: product.transportType,
      label: Object(i18n["h" /* t */])('price.format.flightIncluded')
    });
  }

  if (isOpeningSoon) {
    productTopTags.push({
      className: 'text-white border-orange bg-orange',
      dataTestId: 'ProductThumbnail-openingSoon',
      label: Object(i18n["h" /* t */])('common.openingSoon')
    });
  }

  return productTopTags;
};

var Product_mapper_getProductTags = function getProductTags(product) {
  var productTags = [];

  if (product.mice) {
    var _product$productMeeti, _product$productMeeti2, _product$accommodatio;

    var maxConferenceRoomCapacity = (_product$productMeeti = product.productMeetingRooms) === null || _product$productMeeti === void 0 ? void 0 : (_product$productMeeti2 = _product$productMeeti.meetingRooms) === null || _product$productMeeti2 === void 0 ? void 0 : _product$productMeeti2.reduce(function (roomMaxCapacity, _ref11) {
      var shapes = _ref11.shapes;
      return Math.max(roomMaxCapacity, shapes.reduce(function (maxShape, _ref12) {
        var maxCapacity = _ref12.maxCapacity;
        return Math.max(maxCapacity, maxShape);
      }, 0));
    }, 0);

    if (maxConferenceRoomCapacity) {
      productTags.push({
        className: 'text-sienna bg-white border-white',
        label: Object(i18n["h" /* t */])('common.conferenceRoomCapacity', {
          maxConferenceRoomCapacity: maxConferenceRoomCapacity
        })
      });
    }

    if ((_product$accommodatio = product.accommodationsIntroduction) === null || _product$accommodatio === void 0 ? void 0 : _product$accommodatio.roomsCount) {
      productTags.push({
        className: 'text-sienna border-white bg-white',
        label: Object(i18n["h" /* t */])('common.numberOfRooms', {
          numberOfRooms: product.accommodationsIntroduction.roomsCount
        })
      });
    }

    return productTags;
  }

  if (product.isTour) {
    var _product$rangeLabel;

    var rangeLabel = (_product$rangeLabel = product.rangeLabel) === null || _product$rangeLabel === void 0 ? void 0 : _product$rangeLabel.toUpperCase();
    return [{
      className: 'text-white border-sienna bg-sienna',
      label: product.duration ? "".concat(rangeLabel, " : ").concat(product.duration) : rangeLabel
    }];
  }

  if (product.isCruise) {
    var _product$thematics, _product$thematics$;

    var label = [(_product$thematics = product.thematics) === null || _product$thematics === void 0 ? void 0 : (_product$thematics$ = _product$thematics[0]) === null || _product$thematics$ === void 0 ? void 0 : _product$thematics$.label, product.duration].filter(Boolean).join(' - ');
    return [{
      className: 'text-white border-ultramarine bg-ultramarine',
      label: label
    }];
  }

  if (product.hasECSpace) {
    return [{
      className: 'text-ultramarine border-white bg-white',
      iconName: icons["a" /* ICONS */].DIAMOND,
      label: Object(i18n["h" /* t */])('common.product.exclusiveCollectionSpaceTag')
    }];
  }

  if (product.isExplicitEC) {
    return [{
      className: 'text-ultramarine border-white bg-white',
      iconName: icons["a" /* ICONS */].DIAMOND,
      label: Object(i18n["h" /* t */])('common.product.exclusiveCollectionTag')
    }];
  }
};

var Product_mapper_getProductThumbnailProps = function getProductThumbnailProps(props) {
  var product = props.product,
      _props$isSliderDisabl = props.isSliderDisabled,
      isSliderDisabled = _props$isSliderDisabl === void 0 ? false : _props$isSliderDisabl;
  var openingStatus = product.openingStatus;
  return {
    bottomTags: Product_mapper_getProductTags(product),
    closedLabel: Object(i18n["h" /* t */])('common.closed'),
    isSliderDisabled: isSliderDisabled,
    link: {
      url: getProductUrl(props)
    },
    openingStatus: openingStatus,
    pictures: (product.images || []).map(function (image) {
      return {
        alt: product.name,
        src: image || ''
      };
    }),
    topTags: Product_mapper_getTopTags(props)
  };
};

var getProductFlagProps = function getProductFlagProps(props) {
  var _props$isPriceLoading = props.isPriceLoading,
      isPriceLoading = _props$isPriceLoading === void 0 ? false : _props$isPriceLoading,
      product = props.product;
  var _product$openingStatu = product.openingStatus,
      openingStatus = _product$openingStatu === void 0 ? OPENING_STATUS.OPEN : _product$openingStatu;
  var price = openingStatus === OPENING_STATUS.OPEN ? Product_mapper_getProductPriceProps(props) : {};
  return {
    price: price,
    priceInfo: Product_mapper_getProductPriceInfoProps(props),
    isPriceLoading: isPriceLoading
  };
};

var Product_mapper_getProductOfferDiscountProps = function getProductOfferDiscountProps(_ref13) {
  var product = _ref13.product,
      config = _ref13.config;
  return {
    discount: getAggregateDiscount(product),
    i18n: config.offerDiscount
  };
};

var Product_mapper_createProductUrlWithParams = function createProductUrlWithParams(href, product) {
  var currentLocation = dist["windowWrapper"].getLocation();
  var possibleQueries = [constants["g" /* QUERY_DEPARTURE_DATE */], constants["h" /* QUERY_DURATION */], constants["m" /* QUERY_TRANSPORT */], constants["j" /* QUERY_KIDS */]];

  if (product.isCruise) {
    possibleQueries = [constants["m" /* QUERY_TRANSPORT */]];
  } else if (product.isTour) {
    possibleQueries = [constants["g" /* QUERY_DEPARTURE_DATE */], constants["m" /* QUERY_TRANSPORT */]];
  }

  var getDepartureDate = function getDepartureDate() {
    var _product$flag, _product$flag$price, _product$flag$price$t; // $FlowFixMe


    if (product.departureDateOn && (product === null || product === void 0 ? void 0 : (_product$flag = product.flag) === null || _product$flag === void 0 ? void 0 : (_product$flag$price = _product$flag.price) === null || _product$flag$price === void 0 ? void 0 : (_product$flag$price$t = _product$flag$price.termsAndConditions) === null || _product$flag$price$t === void 0 ? void 0 : _product$flag$price$t.departureDate)) {
      return Object(apiDate["j" /* momentFromApiDate */])(product.flag.price.termsAndConditions.departureDate).format(constants["f" /* QUERY_DATE_FORMAT */]);
    }

    return Object(uriUtils["k" /* getQueryParameters */])(currentLocation)[constants["g" /* QUERY_DEPARTURE_DATE */]] || '';
  };

  return Object(uriUtils["g" /* generateUrlWithParams */])(href, {
    queryParams: possibleQueries.reduce(function (acc, curr) {
      return _objectSpread(_objectSpread({}, acc), {}, Object(defineProperty["a" /* default */])({}, curr, curr === constants["g" /* QUERY_DEPARTURE_DATE */] ? getDepartureDate() : Object(uriUtils["k" /* getQueryParameters */])(currentLocation)[curr] || ''));
    }, // $FlowFixMe
    {})
  });
};

var setProductHref = function setProductHref(props) {
  var _props$product = props.product,
      product = _props$product === void 0 ? {} : _props$product;
  var href = product.href;

  if (href && true) {
    return _objectSpread(_objectSpread({}, props), {}, {
      // $FlowFixMe
      product: _objectSpread(_objectSpread({}, product), {}, {
        href: Product_mapper_createProductUrlWithParams(href, product)
      })
    });
  }

  return props;
};

var Product_mapper_getProductProps = function getProductProps(props) {
  var _props$product3, _props$product3$child, _product$destination2;

  var _props$hasComparison = props.hasComparison,
      hasComparison = _props$hasComparison === void 0 ? false : _props$hasComparison,
      _props$kids = props.kids,
      kids = _props$kids === void 0 ? [] : _props$kids,
      _props$offer = props.offer,
      offer = _props$offer === void 0 ? {} : _props$offer,
      _props$product2 = props.product,
      product = _props$product2 === void 0 ? {} : _props$product2;
  var flag = getProductFlagProps(props);
  var flagPrice = flag.price || {};
  var matchingOfferProducts = offer.products && offer.products.length > 0 ? offer.products.filter(function (offerProduct) {
    return offerProduct.id === product.id;
  }) : [];
  var price = matchingOfferProducts.length === 1 ? matchingOfferProducts.map(function (matchingOfferProduct) {
    return matchingOfferProduct.price;
  }).shift() : flagPrice;
  return {
    childcare: Product_mapper_getProductChildcareAvailabilitiesProps(props),
    childcareAgeInMonths: getChildCareAgeInMonths(props),
    childcareIncluded: (_props$product3 = props.product) === null || _props$product3 === void 0 ? void 0 : (_props$product3$child = _props$product3.childcareDetails) === null || _props$product3$child === void 0 ? void 0 : _props$product3$child.some(function (childcare) {
      return childcare.included;
    }),
    comfort: product.comfort,
    comparison: Product_mapper_getProductComparisonProps(props),
    coordinates: product.coordinates,
    departureDateOn: product.departureDateOn,
    flag: flag,
    hasComparison: hasComparison,
    header: getProductHeaderProps(props),
    id: product.id,
    isCruise: product.isCruise,
    isTour: product.isTour,
    kids: kids,
    minAuthorizedAge: props.product.minAuthorizedAge,
    price: !isEmpty_default()(price) ? price : undefined,
    resortRegion: (_product$destination2 = product.destination) === null || _product$destination2 === void 0 ? void 0 : _product$destination2.area,
    thumbnail: Product_mapper_getProductThumbnailProps(props),
    type: product.type,
    url: getProductUrl(props)
  };
};

var updateProduct = function updateProduct(product, props) {
  return _objectSpread(_objectSpread({}, product), {}, {
    hasComparison: props.hasComparison,
    childcare: Product_mapper_getProductChildcareAvailabilitiesProps(props),
    comparison: Product_mapper_getProductComparisonProps(props),
    flag: getProductFlagProps(props)
  });
};

var Product_mapper_updateProductUrl = function updateProductUrl(product) {
  var newProductUrl = Product_mapper_createProductUrlWithParams(new URI_default.a(product.url).pathname(), product);
  return _objectSpread(_objectSpread({}, product), {}, {
    url: newProductUrl,
    header: _objectSpread(_objectSpread({}, product.header), {}, {
      link: {
        url: newProductUrl
      }
    }),
    // $FlowFixMe
    thumbnail: _objectSpread(_objectSpread({}, product.thumbnail), {}, {
      link: {
        url: newProductUrl
      }
    })
  });
};



/***/ }),

/***/ "igjW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentUri; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isProduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isStrictlyProductionEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isStrictlyStagingEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isStrictlyIntegrationEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isStrictlyTestEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isStrictlyDevelopmentEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentLocale; });
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_2__);



function getCurrentUri(req) {
  return new urijs__WEBPACK_IMPORTED_MODULE_0___default.a(decodeURI(req.originalUrl)).protocol(req.protocol).host(req.get('host'));
}
function isProduction() {
  return _config__WEBPACK_IMPORTED_MODULE_2___default.a.get('DEPLOYMENT_ENV') === 'production';
}
function isStrictlyProductionEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && (cfg.get('DEPLOYMENT_ENV') === 'production' || cfg.get('DEPLOYMENT_ENV') === 'prod');
}
function isStrictlyStagingEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'staging';
}
function isStrictlyIntegrationEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'integration';
}
function isStrictlyTestEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'test';
}
function isStrictlyDevelopmentEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'development' || cfg.get('NODE_ENV') === 'dev';
}
function getCurrentLocale(requestedLocale, hostname) {
  if (requestedLocale) {
    return requestedLocale;
  }

  var domainServiceForHostname = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1___default.a.forHostname(hostname);
  return domainServiceForHostname.getDefaultLocale();
}

/***/ }),

/***/ "iiKe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ CheckedList_CheckedList; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/frameworks/checked-list/CheckedList.themes.js
var themes = {
  "default": {
    thTitle: 'mb-20',
    thList: 'sm:columns-2 -m-5',
    thListItem: 'flex gap-10 p-5',
    thIcon: 'bg-green shrink-0 p-5 rounded-full text-white',
    thIconWidth: '1.2em'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/checked-list/CheckedList.jsx

var __jsx = react_default.a.createElement;






var CheckedList_CheckedList = function CheckedList(_ref) {
  var children = _ref.children,
      className = _ref.className,
      itemClassName = _ref.itemClassName,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title;

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thTitle = _themes$theme.thTitle,
      thList = _themes$theme.thList,
      thListItem = _themes$theme.thListItem,
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth;
  return __jsx(react["Fragment"], null, title && __jsx(Title["a" /* Title */], {
    className: thTitle,
    theme: "title-sans-n3"
  }, title), __jsx("ul", {
    className: Object(classnames_utils["a" /* classnames */])(thList, className)
  }, react["Children"].map(children, function (child, idx) {
    return __jsx("li", {
      className: Object(classnames_utils["a" /* classnames */])(itemClassName, thListItem),
      key: idx
    }, __jsx(Icon["a" /* Icon */], {
      className: thIcon,
      name: icons["a" /* ICONS */].CHECK,
      width: thIconWidth
    }), child);
  })));
};

/***/ }),

/***/ "nZ6J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export descriptors */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getComponent; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("m9LP");
/* harmony import */ var core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("87if");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("hNT8");
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("psNz");







 // const mod = ({ Component }) => Component;

var descriptors = new Map([
/* layout lines */
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* PAGE_TRACKING */ "H"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(123)]).then(__webpack_require__.bind(null, "sLNG"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("sLNG")];
    },
    modules: ["./tracking/descriptor"]
  }
})],
/* common lines */
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* ALL_INCLUSIVE_PUSH */ "a"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(176)]).then(__webpack_require__.bind(null, "DS8N"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("DS8N")];
    },
    modules: ["./all-inclusive-push/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* BRAND_PROMISE */ "b"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(162)]).then(__webpack_require__.bind(null, "WtX0"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("WtX0")];
    },
    modules: ["./brand-promise/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* BRAND_SUPERIORITY */ "c"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(18), __webpack_require__.e(161)]).then(__webpack_require__.bind(null, "JRrv"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("JRrv")];
    },
    modules: ["./brand-superiority/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* BUTTON_TICKET */ "d"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(177)]).then(__webpack_require__.bind(null, "ISYn"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("ISYn")];
    },
    modules: ["./button-ticket/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* CHECKLIST */ "e"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(20), __webpack_require__.e(178)]).then(__webpack_require__.bind(null, "4LJ+"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("4LJ+")];
    },
    modules: ["./checklist/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* COMPARISON_TABLE */ "f"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(18), __webpack_require__.e(125)]).then(__webpack_require__.bind(null, "IjOA"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("IjOA")];
    },
    modules: ["./comparison-table/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* CRISIS_ALERT */ "g"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(152)]).then(__webpack_require__.bind(null, "3c8P"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("3c8P")];
    },
    modules: ["./crisis-alert/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* DESTINATIONS */ "j"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(134)]).then(__webpack_require__.bind(null, "UYKV"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("UYKV")];
    },
    modules: ["./destinations/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* DOWNLOAD_LINKS_LIST */ "k"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(163)]).then(__webpack_require__.bind(null, "yTkl"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("yTkl")];
    },
    modules: ["./download-links-list/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* EDITORIAL_FOLDING_BLOCK */ "l"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(154)]).then(__webpack_require__.bind(null, "ms+y"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("ms+y")];
    },
    modules: ["./editorial-folding-block/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* EVENT_ANIMATION */ "m"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(35), __webpack_require__.e(184)]).then(__webpack_require__.bind(null, "ddrH"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("ddrH")];
    },
    modules: ["./event-animation/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* EVENT_FORM */ "n"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(187)]).then(__webpack_require__.bind(null, "jvJq"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("jvJq")];
    },
    modules: ["./event-form/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* EVENT_FORM_AFFINITY */ "o"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(185)]).then(__webpack_require__.bind(null, "CnbF"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("CnbF")];
    },
    modules: ["./event-form-affinity/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* IMMERSIVE */ "t"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(149)]).then(__webpack_require__.bind(null, "RgPE"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("RgPE")];
    },
    modules: ["./immersive/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* INSPIRATIONAL_GRID */ "u"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(29)]).then(__webpack_require__.bind(null, "3Fn9"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("3Fn9")];
    },
    modules: ["./inspirational-grid/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* LAST_SEEN_PRODUCTS */ "v"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(22), __webpack_require__.e(133)]).then(__webpack_require__.bind(null, "Qdj2"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Qdj2")];
    },
    modules: ["./last-seen-products/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* MEDIA_TEXT_HORIZONTAL */ "w"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(136)]).then(__webpack_require__.bind(null, "xoIU"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("xoIU")];
    },
    modules: ["./media-text-horizontal/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* MEDIA_TEXT_VERTICAL */ "x"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(137)]).then(__webpack_require__.bind(null, "jyQO"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("jyQO")];
    },
    modules: ["./media-text-vertical/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* MEDIA_THUMBNAIL */ "y"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(138)]).then(__webpack_require__.bind(null, "YWPa"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("YWPa")];
    },
    modules: ["./media-thumbnail/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* NAVIGATION_TAB */ "A"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 195).then(__webpack_require__.bind(null, "Q52w"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Q52w")];
    },
    modules: ["./navigation-tab/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* NAVIGATION_TABS */ "B"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(116)]).then(__webpack_require__.bind(null, "LNeH"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("LNeH")];
    },
    modules: ["./navigation-tabs/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* OFFERS_GRID */ "C"], function () {
  return next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
    return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(131)]).then(__webpack_require__.bind(null, "wqTy"));
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/("wqTy")];
      },
      modules: ["./offers-grid/descriptor"]
    }
  });
}], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* OFFERS_PUSH */ "D"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(144)]).then(__webpack_require__.bind(null, "A3qt"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("A3qt")];
    },
    modules: ["./offers-push/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PREBOOKING_FORM */ "I"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(124)]).then(__webpack_require__.bind(null, "1w3z"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("1w3z")];
    },
    modules: ["./prebooking-form/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_TAGS */ "V"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(129)]).then(__webpack_require__.bind(null, "KQqJ"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("KQqJ")];
    },
    modules: ["./product-tags/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCTS_FILTERS */ "J"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(13), __webpack_require__.e(120)]).then(__webpack_require__.bind(null, "s++G"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("s++G")];
    },
    modules: ["./products-filters/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_GRID */ "kb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(13), __webpack_require__.e(118)]).then(__webpack_require__.bind(null, "bNOZ"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("bNOZ")];
    },
    modules: ["./products-grid/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* SECTION */ "wb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 253).then(__webpack_require__.bind(null, "0BFP"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("0BFP")];
    },
    modules: ["./section/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* SECTIONS */ "xb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(20), __webpack_require__.e(254)]).then(__webpack_require__.bind(null, "qsa7"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("qsa7")];
    },
    modules: ["./sections/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* SMART_FAQ */ "yb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 256).then(__webpack_require__.bind(null, "+2Bl"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("+2Bl")];
    },
    modules: ["./smart-faq/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* SUBMISSION_STATUS */ "zb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(9), __webpack_require__.e(173)]).then(__webpack_require__.bind(null, "FQba"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("FQba")];
    },
    modules: ["./submission-status/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TAB */ "Ab"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 257).then(__webpack_require__.bind(null, "mM3U"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("mM3U")];
    },
    modules: ["./tab/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TABS */ "Bb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(132)]).then(__webpack_require__.bind(null, "B07w"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("B07w")];
    },
    modules: ["./tabs/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TEASER_CARDS */ "Cb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(122)]).then(__webpack_require__.bind(null, "6DS4"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("6DS4")];
    },
    modules: ["./teaser-cards/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TEST_AB */ "Db"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 151).then(__webpack_require__.bind(null, "O94t"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("O94t")];
    },
    modules: ["./test-ab/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TEXT */ "Eb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(0), __webpack_require__.e(259)]).then(__webpack_require__.bind(null, "dJAn"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("dJAn")];
    },
    modules: ["./text/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* THEMATIC */ "Fb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(174)]).then(__webpack_require__.bind(null, "TgTY"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("TgTY")];
    },
    modules: ["./thematic/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TITLE_AND_TEXT */ "Gb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(147)]).then(__webpack_require__.bind(null, "aMVx"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("aMVx")];
    },
    modules: ["./title-and-text/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TRAVEL_RESTRICTIONS */ "Kb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(143)]).then(__webpack_require__.bind(null, "T5EZ"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("T5EZ")];
    },
    modules: ["./travel-restrictions/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TRIPADVISOR_TESTIMONY */ "Lb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(156)]).then(__webpack_require__.bind(null, "GSMs"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("GSMs")];
    },
    modules: ["./tripadvisor-testimony/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* VIDEO */ "Mb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(0), __webpack_require__.e(157)]).then(__webpack_require__.bind(null, "K7yN"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("K7yN")];
    },
    modules: ["./video/descriptor"]
  }
})],
/* home lines : homepage recommended */
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* HIGHLIGHT */ "s"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(148)]).then(__webpack_require__.bind(null, "+nt3"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("+nt3")];
    },
    modules: ["./highlight/descriptor"]
  }
})],
/* offer lines : offerId needed */
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* OFFER_DESCRIPTION */ "E"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(146)]).then(__webpack_require__.bind(null, "wq1+"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("wq1+")];
    },
    modules: ["./offer-description/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* OFFER_LEGAL_INFORMATION */ "F"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(166)]).then(__webpack_require__.bind(null, "Z6pd"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Z6pd")];
    },
    modules: ["./offer-legal-information/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* OFFER_SEO */ "G"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 199).then(__webpack_require__.bind(null, "7YIZ"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("7YIZ")];
    },
    modules: ["./offer-seo/descriptor"]
  }
})],
/* cruise lines : resortId/productId needed (only cruise ID) */
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* CRUISE_BOOKING */ "h"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(153)]).then(__webpack_require__.bind(null, "oD44"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("oD44")];
    },
    modules: ["./cruise-booking/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* CRUISE_PROGRAM */ "i"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(181)]).then(__webpack_require__.bind(null, "NTfX"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("NTfX")];
    },
    modules: ["./cruise-program/descriptor"]
  }
})], // no ID needed but commonly on cruise page

/* product lines : resortId/productId needed */
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* EXCLUSIVE_COLLECTION_SPACE */ "p"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(165)]).then(__webpack_require__.bind(null, "26Xc"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("26Xc")];
    },
    modules: ["./exclusive-collection-space/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* EXCLUSIVE_COLLECTION_SPACE_INTRODUCTION */ "q"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(164)]).then(__webpack_require__.bind(null, "eiEl"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("eiEl")];
    },
    modules: ["./exclusive-collection-space-introduction/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* HAPPY_TO_CARE */ "r"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(191)]).then(__webpack_require__.bind(null, "JxsF"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("JxsF")];
    },
    modules: ["./happy-to-care/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_ACCESS_AND_MAP */ "cb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(167)]).then(__webpack_require__.bind(null, "Je/+"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Je/+")];
    },
    modules: ["./product-access-and-map/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_ACCOMMODATION_TYPES */ "eb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(206)]).then(__webpack_require__.bind(null, "m1uF"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("m1uF")];
    },
    modules: ["./product-accommodations/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_ACCOMMODATION_EXCLUSIVE_COLLECTION */ "db"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(204)]).then(__webpack_require__.bind(null, "Kbtl"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Kbtl")];
    },
    modules: ["./product-accommodations-exclusive/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_ACTIVITIES */ "K"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(9), __webpack_require__.e(114)]).then(__webpack_require__.bind(null, "GSnJ"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("GSnJ")];
    },
    modules: ["./product-activities/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_BARS */ "fb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(207)]).then(__webpack_require__.bind(null, "TFik"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("TFik")];
    },
    modules: ["./product-bars/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_BOOKING_BE */ "gb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(209)]).then(__webpack_require__.bind(null, "EgjI"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("EgjI")];
    },
    modules: ["./product-booking/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_BREADCRUMB */ "L"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(211)]).then(__webpack_require__.bind(null, "gfEP"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("gfEP")];
    },
    modules: ["./product-breadcrumb/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_CHILDCARES */ "M"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(14), __webpack_require__.e(119)]).then(__webpack_require__.bind(null, "uvus"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("uvus")];
    },
    modules: ["./product-childcares/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_DESTINATION */ "hb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(35), __webpack_require__.e(170)]).then(__webpack_require__.bind(null, "Smcz"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Smcz")];
    },
    modules: ["./product-destination/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_DISTRICT */ "ib"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(252)]).then(__webpack_require__.bind(null, "YkGc"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("YkGc")];
    },
    modules: ["./resort-district/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_FLASH_INFO */ "jb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(139)]).then(__webpack_require__.bind(null, "1Ak6"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("1Ak6")];
    },
    modules: ["./product-flash-info/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_STREET_VIEW */ "T"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(215)]).then(__webpack_require__.bind(null, "yWVM"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("yWVM")];
    },
    modules: ["./product-google-street-view/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_IMAGE_MAP */ "N"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(217)]).then(__webpack_require__.bind(null, "YY1v"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("YY1v")];
    },
    modules: ["./product-image-map/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_IMMERSIVE */ "O"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(130)]).then(__webpack_require__.bind(null, "Nn0M"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Nn0M")];
    },
    modules: ["./product-immersive/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_INFORMATION_SUMMARY */ "P"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(171)]).then(__webpack_require__.bind(null, "PeCK"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("PeCK")];
    },
    modules: ["./product-information-summary/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_INTRODUCTION */ "lb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(29), __webpack_require__.e(140)]).then(__webpack_require__.bind(null, "3cys"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("3cys")];
    },
    modules: ["./product-introduction/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_MEETING_ROOM_INFO */ "mb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(222)]).then(__webpack_require__.bind(null, "DnnJ"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("DnnJ")];
    },
    modules: ["./product-meeting-room-info/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_MULTIMEDIA */ "nb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(135)]).then(__webpack_require__.bind(null, "mxuP"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("mxuP")];
    },
    modules: ["./product-multimedia/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* MUST_TRY_EXPERIENCES */ "z"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(225)]).then(__webpack_require__.bind(null, "wvxA"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("wvxA")];
    },
    modules: ["./product-must-try-experiences/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_PRICE_REMOTE */ "ob"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(126)]).then(__webpack_require__.bind(null, "FLWE"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("FLWE")];
    },
    modules: ["./product-price-remote/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_PRICE_TICKET */ "pb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(230)]).then(__webpack_require__.bind(null, "eGWY"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("eGWY")];
    },
    modules: ["./product-price-ticket/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_PRICE_TICKET_CUSTOM */ "Q"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(228)]).then(__webpack_require__.bind(null, "S5GU"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("S5GU")];
    },
    modules: ["./product-price-ticket-custom/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* QRCODE_PRODUCT_BARS */ "W"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(250)]).then(__webpack_require__.bind(null, "cmoa"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("cmoa")];
    },
    modules: ["./qrcode-product-bars/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* QRCODE_PRODUCT_DRESSCODE */ "X"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(127)]).then(__webpack_require__.bind(null, "zyV9"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("zyV9")];
    },
    modules: ["./qrcode-product-dresscode/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* QRCODE_PRODUCT_PROGRAM */ "Y"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(128)]).then(__webpack_require__.bind(null, "vLcP"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("vLcP")];
    },
    modules: ["./qrcode-product-program/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* QRCODE_PRODUCT_RESTAURANTS */ "Z"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(251)]).then(__webpack_require__.bind(null, "tjsQ"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("tjsQ")];
    },
    modules: ["./qrcode-product-restaurants/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* QUOTATION_FORM */ "ab"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(155)]).then(__webpack_require__.bind(null, "bpGR"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("bpGR")];
    },
    modules: ["./product-quotation-form/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_RECOMMENDATIONS */ "qb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(22), __webpack_require__.e(141)]).then(__webpack_require__.bind(null, "qmxF"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("qmxF")];
    },
    modules: ["./product-recommendations/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RELATED_PRODUCTS */ "bb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(234)]).then(__webpack_require__.bind(null, "CSWM"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("CSWM")];
    },
    modules: ["./product-related-products/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_RESTAURANTS */ "rb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(236)]).then(__webpack_require__.bind(null, "08wu"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("08wu")];
    },
    modules: ["./product-restaurants/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_SEO */ "sb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 238).then(__webpack_require__.bind(null, "CS9y"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("CS9y")];
    },
    modules: ["./product-seo-title/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_SERVICES */ "R"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(150)]).then(__webpack_require__.bind(null, "Z4cC"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("Z4cC")];
    },
    modules: ["./product-services/descriptor"]
  }
})], // no ID but commonly on product page
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_SIGNATURES */ "S"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(241)]).then(__webpack_require__.bind(null, "flGr"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("flGr")];
    },
    modules: ["./product-signatures/descriptor"]
  }
})], // no ID but commonly on product page
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* PRODUCT_STRENGTHS */ "U"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(242)]).then(__webpack_require__.bind(null, "0a2G"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("0a2G")];
    },
    modules: ["./product-strengths/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_SUMMARY */ "tb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(244)]).then(__webpack_require__.bind(null, "/rmy"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("/rmy")];
    },
    modules: ["./product-summary/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_TRIPADVISOR */ "vb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(145)]).then(__webpack_require__.bind(null, "G5yF"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("G5yF")];
    },
    modules: ["./product-tripadvisor/descriptor"]
  }
})],
/* tour lines : resortId/productId needed (only tour ID) */
[_constants__WEBPACK_IMPORTED_MODULE_7__[/* TOUR_INTRODUCTION */ "Hb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(262)]).then(__webpack_require__.bind(null, "LQjd"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("LQjd")];
    },
    modules: ["./tour-introduction/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TOUR_PRACTICAL_INFORMATION */ "Ib"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(264)]).then(__webpack_require__.bind(null, "9xag"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("9xag")];
    },
    modules: ["./tour-practical-information/descriptor"]
  }
})], [_constants__WEBPACK_IMPORTED_MODULE_7__[/* TOUR_PROGRAM */ "Jb"], next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1), __webpack_require__.e(2), __webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(266)]).then(__webpack_require__.bind(null, "cKQV"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("cKQV")];
    },
    modules: ["./tour-program/descriptor"]
  }
})]]);
var hasComponent = function hasComponent(name) {
  return descriptors.has(name);
};
var getComponent = function getComponent(name) {
  if (!descriptors.has(name)) {
    return null;
  }

  return descriptors.get(name);
};

/***/ }),

/***/ "oG87":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorBoundary; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("OZaJ");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _errors_clientErrorHandler__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("aPQG");
/* harmony import */ var _utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("igjW");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var ErrorBoundaryComponent = /*#__PURE__*/function (_React$Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(ErrorBoundaryComponent, _React$Component);

  var _super = _createSuper(ErrorBoundaryComponent);

  function ErrorBoundaryComponent(props) {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this, ErrorBoundaryComponent);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(ErrorBoundaryComponent, [{
    key: "componentDidCatch",
    // eslint-disable-next-line class-methods-use-this
    value: function componentDidCatch(error, info) {
      Object(_errors_clientErrorHandler__WEBPACK_IMPORTED_MODULE_12__[/* handleComponentError */ "a"])(error, info);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          router = _this$props.router,
          children = _this$props.children;

      if (this.state.hasError) {
        if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_13__[/* isStrictlyProductionEnv */ "f"])()) {
          var locale = router.query.locale;
          router.replace({
            pathname: '/500',
            query: Boolean(locale) && {
              locale: locale
            }
          });
          this.setState({
            hasError: false
          });
        }

        return null;
      }

      return children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundaryComponent;
}(react__WEBPACK_IMPORTED_MODULE_10___default.a.Component);

var ErrorBoundary = Object(next_router__WEBPACK_IMPORTED_MODULE_11__["withRouter"])(ErrorBoundaryComponent);

/***/ }),

/***/ "pWxA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _assertThisInitialized; });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),

/***/ "sRHE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _getPrototypeOf; });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "tCJK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Sections_Sections; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// CONCATENATED MODULE: ./src/client/components/frameworks/intersection-observer/createIntersectionObserver.js
if (true) {
  // Polyfills for intersection-observer
  __webpack_require__("LNcM");
}

function createIntersectionObserver(callback, options) {
  // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
  return new IntersectionObserver(callback, options);
}
// CONCATENATED MODULE: ./src/client/components/frameworks/intersection-observer/IntersectionObserver.jsx













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }



var IntersectionObserver_IntersectionObserver = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(IntersectionObserver, _Component);

  var _super = _createSuper(IntersectionObserver);

  function IntersectionObserver() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, IntersectionObserver);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleIntersection", function (_ref) {
      var _ref2 = Object(slicedToArray["a" /* default */])(_ref, 1),
          entry = _ref2[0];

      _this.props.onChange(entry);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "observe", function () {
      if (_this.target && _this.observer) {
        _this.observer.observe(_this.target);
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "unobserve", function () {
      if (_this.target && _this.observer) {
        _this.observer.unobserve(_this.target);
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "setRefTarget", function (target) {
      _this.targetChanged = _this.previousTarget && _this.previousTarget !== target;

      if (_this.targetChanged) {
        _this.unobserve();
      }

      _this.target = target;
    });

    return _this;
  }

  Object(createClass["a" /* default */])(IntersectionObserver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          rootMargin = _this$props.rootMargin,
          threshold = _this$props.threshold;
      this.observer = createIntersectionObserver(this.handleIntersection, {
        rootMargin: rootMargin,
        threshold: threshold
      });
      this.observe();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unobserve();

      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      // @todo remove this
      this.previousTarget = this.target;
      return /*#__PURE__*/react_default.a.cloneElement(react_default.a.Children.only(this.props.children), {
        ref: this.setRefTarget
      });
    }
  }]);

  return IntersectionObserver;
}(react["Component"]);

Object(defineProperty["a" /* default */])(IntersectionObserver_IntersectionObserver, "displayName", 'IntersectionObserver');

Object(defineProperty["a" /* default */])(IntersectionObserver_IntersectionObserver, "defaultProps", {
  rootMargin: '0px',
  threshold: 0
});
// CONCATENATED MODULE: ./src/client/components/frameworks/section/Section.jsx











var __jsx = react_default.a.createElement;

function Section_createSuper(Derived) { var hasNativeReflectConstruct = Section_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function Section_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var Section_Section = /*#__PURE__*/function (_PureComponent) {
  Object(inherits["a" /* default */])(Section, _PureComponent);

  var _super = Section_createSuper(Section);

  function Section(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Section);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "intersectionObserverThreshold", void 0);

    _this.intersectionObserverThreshold = [];

    for (var i = 0; i <= 1.0; i += 0.01) {
      // Get notified of every percent of visiblity change in the viewport (1% of intersection to 100%)
      _this.intersectionObserverThreshold.push(Math.round(i * 100) / 100);
    }

    return _this;
  }

  Object(createClass["a" /* default */])(Section, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          index = _this$props.index,
          name = _this$props.name;
      var anchor = name ? dist["url"].normalizeSlug(name) : null;
      return __jsx(IntersectionObserver_IntersectionObserver, {
        onChange: this.props.onSectionIntersectViewport,
        threshold: this.intersectionObserverThreshold
      }, __jsx("section", {
        className: className,
        "data-cs-override-id": "Section",
        "data-index": index,
        "data-testid": "section",
        id: anchor || null
      }, children));
    }
  }]);

  return Section;
}(react["PureComponent"]);

Object(defineProperty["a" /* default */])(Section_Section, "defaultProps", {
  name: ''
});
// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// EXTERNAL MODULE: ./src/client/components/frameworks/nav-tag/NavTag.jsx + 1 modules
var NavTag = __webpack_require__("UXOF");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// CONCATENATED MODULE: ./src/client/components/frameworks/sections/Sections.jsx





var Sections_jsx = react_default.a.createElement;








var Sections_Sections = function Sections(_ref) {
  var children = _ref.children,
      className = _ref.className,
      navItems = _ref.navItems,
      getTrackingData = _ref.getTrackingData,
      scrollBackwardLabel = _ref.scrollBackwardLabel,
      scrollForwardLabel = _ref.scrollForwardLabel,
      pageType = _ref.pageType;
  var track = Object(useTracking["a" /* useTracking */])();
  var navBarRef = Object(react["useRef"])(null);
  var onSectionIntersectViewport = Object(react["useRef"])(noop_default.a);

  var _useState = Object(react["useState"])(0),
      selectedIndex = _useState[0],
      setSelectedIndex = _useState[1];

  var navSelector = pageType || 'Sections'; // eslint-disable-next-line no-unused-vars

  var _useState2 = Object(react["useState"])(false),
      isSticky = _useState2[0],
      setIsSticky = _useState2[1];

  var onNavItemClick = Object(react["useCallback"])(function (anchor, index, label) {
    return function (e) {
      e.preventDefault(); // $FlowFixMe

      var selected = Number(index);
      var scrollRootOffsetSelector = "#".concat(navSelector);

      if (getTrackingData) {
        track(getTrackingData(label));
      }

      Object(scrollToElement["a" /* scrollToElement */])("#".concat(anchor), 600, scrollRootOffsetSelector).then(function () {
        setSelectedIndex(selected);
      });
    };
  }, []);
  var navbarItems = Object(react["useMemo"])(function () {
    return navItems.map(function (label, index) {
      var anchor = label ? dist["url"].normalizeSlug(label) : '';
      return {
        href: "#".concat(anchor),
        label: label,
        onClick: anchor ? onNavItemClick(anchor, index, label) : noop_default.a
      };
    });
  }, [navItems]);
  Object(react["useEffect"])(function () {
    if (!isSticky) {
      setSelectedIndex(0);
    }
  }, [isSticky]);
  Object(react["useEffect"])(function () {
    onSectionIntersectViewport.current = function (event) {
      var visiblePercentage = Math.floor(event.intersectionRatio * 100);

      var navBarHeight = navBarRef && get_default()(navBarRef, 'current.offsetHeight');

      var selected = Number(event.target.dataset.index);

      if (event.isIntersecting && visiblePercentage > 10 && event.intersectionRect.top <= navBarHeight) {
        setSelectedIndex(selected);
      }
    };
  }, []);
  Object(react["useEffect"])(function () {
    var element = navBarRef.current;
    var observer = new IntersectionObserver(function (_ref2) {
      var _ref3 = Object(slicedToArray["a" /* default */])(_ref2, 1),
          e = _ref3[0];

      return setIsSticky(e.intersectionRatio < 1);
    }, {
      threshold: [1]
    });

    if (element) {
      observer.observe(element);
      return function () {
        return observer.unobserve(element);
      };
    }
  }, [navBarRef]);
  return Sections_jsx("div", {
    className: className
  }, Sections_jsx("div", {
    ref: navBarRef,
    id: navSelector,
    className: Object(classnames_utils["a" /* classnames */])('sticky -top-1 mx-auto flex w-full flex-wrap bg-white', {
      'z-8 border-b-1': isSticky
    })
  }, Sections_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: scrollBackwardLabel,
    childrenWrapperClassNames: "flex gap-10",
    className: "w-full max-w-site bg-white py-10 lg:mx-auto",
    forceDisplayControls: true,
    forwardLabel: scrollForwardLabel
  }, navbarItems.map(function (item, index) {
    return Sections_jsx(NavTag["a" /* NavTag */], {
      href: item.href,
      isActive: index === selectedIndex,
      key: item.label,
      onClick: item.onClick
    }, item.label);
  }))), react["Children"].map(children, function (section, index) {
    return Sections_jsx(Section_Section, {
      index: index,
      key: navItems[index],
      name: navItems[index],
      onSectionIntersectViewport: onSectionIntersectViewport.current
    }, section);
  }));
};
Sections_Sections.defaultProps = {
  children: [],
  navItems: [],
  pageType: ''
};

/***/ }),

/***/ "w04c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductsGrid_ProductsGrid; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../domains-service/dist/index.js
var dist = __webpack_require__("g/E1");

// EXTERNAL MODULE: ./src/client/components/frameworks/grid/Grid.jsx + 1 modules
var Grid = __webpack_require__("uLWw");

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.jsx + 5 modules
var Product = __webpack_require__("XTOr");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: ./src/utils/api-status/constants.js
var constants = __webpack_require__("54uq");

// CONCATENATED MODULE: ./src/utils/products/productsUtils.js







function sortProductsByPriceAsc(_ref, _ref2) {
  var _priceA$bestPrice, _priceB$bestPrice;

  var priceA = _ref.price;
  var priceB = _ref2.price; // equal items sort equally

  if ((priceA === null || priceA === void 0 ? void 0 : (_priceA$bestPrice = priceA.bestPrice) === null || _priceA$bestPrice === void 0 ? void 0 : _priceA$bestPrice.value) === (priceB === null || priceB === void 0 ? void 0 : (_priceB$bestPrice = priceB.bestPrice) === null || _priceB$bestPrice === void 0 ? void 0 : _priceB$bestPrice.value)) {
    return 0;
  } // nulls sort after anything else


  if (!(priceA === null || priceA === void 0 ? void 0 : priceA.bestPrice)) {
    return 1;
  }

  if (!(priceB === null || priceB === void 0 ? void 0 : priceB.bestPrice)) {
    return -1;
  }

  return (priceA === null || priceA === void 0 ? void 0 : priceA.bestPrice.value) < (priceB === null || priceB === void 0 ? void 0 : priceB.bestPrice.value) ? -1 : 1;
}

function sortProductsByPriceDesc(_ref3, _ref4) {
  var _priceA$bestPrice2, _priceB$bestPrice2;

  var priceA = _ref3.price;
  var priceB = _ref4.price; // equal items sort equally

  if ((priceA === null || priceA === void 0 ? void 0 : (_priceA$bestPrice2 = priceA.bestPrice) === null || _priceA$bestPrice2 === void 0 ? void 0 : _priceA$bestPrice2.value) === (priceB === null || priceB === void 0 ? void 0 : (_priceB$bestPrice2 = priceB.bestPrice) === null || _priceB$bestPrice2 === void 0 ? void 0 : _priceB$bestPrice2.value)) {
    return 0;
  } // nulls sort after anything else


  if (!(priceA === null || priceA === void 0 ? void 0 : priceA.bestPrice)) {
    return 1;
  }

  if (!(priceB === null || priceB === void 0 ? void 0 : priceB.bestPrice)) {
    return -1;
  }

  return (priceA === null || priceA === void 0 ? void 0 : priceA.bestPrice.value) < (priceB === null || priceB === void 0 ? void 0 : priceB.bestPrice.value) ? 1 : -1;
}

function sortProductsByPrice(products, orderByPrice) {
  var sortFunction = orderByPrice === 'asc' ? sortProductsByPriceAsc : sortProductsByPriceDesc;
  return Object(toConsumableArray["a" /* default */])(products).sort(sortFunction);
}

function sortProductsByChildcareAvailabilityDesc(productA, productB) {
  var _productA$childcare, _productB$childcare;

  var numberOfChildcaresWithBestAvailabilityA = 0;
  var childcareItemsA = (productA === null || productA === void 0 ? void 0 : (_productA$childcare = productA.childcare) === null || _productA$childcare === void 0 ? void 0 : _productA$childcare.items) || [];

  if (childcareItemsA.length > 0) {
    childcareItemsA.forEach(function (_ref5) {
      var availability = _ref5.availability,
          isIncluded = _ref5.isIncluded,
          remainingStock = _ref5.remainingStock;

      if (remainingStock === null) {
        if (isIncluded && availability === constants["b" /* API_AVAILABLE */]) {
          numberOfChildcaresWithBestAvailabilityA++;
        }
      } else if (remainingStock >= 10) {
        numberOfChildcaresWithBestAvailabilityA++;
      }
    });
  }

  var numberOfChildcaresWithBestAvailabilityB = 0;
  var childcareItemsB = (productB === null || productB === void 0 ? void 0 : (_productB$childcare = productB.childcare) === null || _productB$childcare === void 0 ? void 0 : _productB$childcare.items) || [];

  if (childcareItemsB.length > 0) {
    childcareItemsB.forEach(function (_ref6) {
      var availability = _ref6.availability,
          isIncluded = _ref6.isIncluded,
          remainingStock = _ref6.remainingStock;

      if (remainingStock === null) {
        if (isIncluded && availability === constants["b" /* API_AVAILABLE */]) {
          numberOfChildcaresWithBestAvailabilityB++;
        }
      } else if (remainingStock >= 10) {
        numberOfChildcaresWithBestAvailabilityB++;
      }
    });
  }

  if (numberOfChildcaresWithBestAvailabilityA === numberOfChildcaresWithBestAvailabilityB) {
    return 0;
  }

  return numberOfChildcaresWithBestAvailabilityA < numberOfChildcaresWithBestAvailabilityB ? 1 : -1;
}

function sortProductsByChildcareAvailability(products, orderByPrice) {
  var productsWithBestChildcareAvailability = [];
  var productsWithChildcareAvailability = [];
  var productsWithMissingChildcareAvailability = [];
  products.forEach(function (product) {
    var _product$childcare;

    var remainingStockGreaterOrEqualTo10Count = 0;
    var unavailableCount = 0;
    var childcareItems = (product === null || product === void 0 ? void 0 : (_product$childcare = product.childcare) === null || _product$childcare === void 0 ? void 0 : _product$childcare.items) || [];

    if (childcareItems.length > 0) {
      childcareItems.forEach(function (_ref7) {
        var availability = _ref7.availability,
            isIncluded = _ref7.isIncluded,
            remainingStock = _ref7.remainingStock;

        if (remainingStock === null) {
          if (isIncluded && availability === constants["b" /* API_AVAILABLE */]) {
            remainingStockGreaterOrEqualTo10Count++;
          } else {
            unavailableCount++;
          }
        } else if (remainingStock >= 10) {
          remainingStockGreaterOrEqualTo10Count++;
        } else if (remainingStock === 0) {
          unavailableCount++;
        }
      });
    } else {
      unavailableCount++;
    }

    if (unavailableCount > 0) {
      productsWithMissingChildcareAvailability.push(product);
    } else if (remainingStockGreaterOrEqualTo10Count === childcareItems.length) {
      productsWithBestChildcareAvailability.push(product);
    } else {
      productsWithChildcareAvailability.push(product);
    }
  });
  return orderByPrice ? [].concat(Object(toConsumableArray["a" /* default */])(sortProductsByPrice(productsWithBestChildcareAvailability, orderByPrice)), Object(toConsumableArray["a" /* default */])(sortProductsByPrice(productsWithChildcareAvailability, orderByPrice)), Object(toConsumableArray["a" /* default */])(sortProductsByPrice(productsWithMissingChildcareAvailability, orderByPrice))) : [].concat(productsWithBestChildcareAvailability, Object(toConsumableArray["a" /* default */])(productsWithChildcareAvailability.sort(sortProductsByChildcareAvailabilityDesc)), Object(toConsumableArray["a" /* default */])(productsWithMissingChildcareAvailability.sort(sortProductsByChildcareAvailabilityDesc)));
}


// CONCATENATED MODULE: ./src/client/components/widgets/products-grid/ProductsGrid.jsx


var __jsx = react_default.a.createElement;






var ProductsGrid_ProductsGrid = function ProductsGrid(_ref) {
  var childrenClassName = _ref.childrenClassName,
      className = _ref.className,
      display = _ref.display,
      fetchData = _ref.fetchData,
      grid = _ref.grid,
      hasSeeMore = _ref.hasSeeMore,
      isLoading = _ref.isLoading,
      _ref$isSynchronousGri = _ref.isSynchronousGrid,
      isSynchronousGrid = _ref$isSynchronousGri === void 0 ? false : _ref$isSynchronousGri,
      lineName = _ref.lineName,
      offer = _ref.offer,
      onComparisonClick = _ref.onComparisonClick,
      _ref$orderByChildcare = _ref.orderByChildcareAvailability,
      orderByChildcareAvailability = _ref$orderByChildcare === void 0 ? false : _ref$orderByChildcare,
      orderByPrice = _ref.orderByPrice,
      products = _ref.products,
      seeMore = _ref.seeMore,
      totalNumberToDisplay = _ref.totalNumberToDisplay;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  if (products.length === 0) {
    return null;
  }

  var cmtaLinks = Object(dist["getCmtaLinks"])(appContext.locale);
  var productListSorted;

  if (orderByChildcareAvailability) {
    productListSorted = sortProductsByChildcareAvailability(products, orderByPrice);
  } else {
    productListSorted = orderByPrice ? sortProductsByPrice(products, orderByPrice) : products;
  }

  return __jsx(Grid["a" /* default */], {
    className: className,
    childrenClassName: childrenClassName,
    display: display || grid,
    getChildren: fetchData,
    grid: grid,
    hasSeeMore: hasSeeMore,
    isLoading: isLoading,
    seeMore: seeMore,
    totalNumberToDisplay: totalNumberToDisplay,
    isSynchronousGrid: isSynchronousGrid
  }, productListSorted.map(function (product, index) {
    return __jsx(Product["a" /* Product */], Object(esm_extends["a" /* default */])({
      cmtaLinks: cmtaLinks,
      index: index,
      key: product.id,
      lineName: lineName,
      offer: offer,
      onComparisonClick: onComparisonClick ? function () {
        return onComparisonClick(product.id);
      } : undefined
    }, product));
  }));
};
ProductsGrid_ProductsGrid.defaultProps = {
  hasSeeMore: false,
  products: []
};

/***/ }),

/***/ "wNDy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ NotFoundError; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ BadRequest; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ ClientSideError; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ ProposalNotFound; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ errors_ApiException; });

// UNUSED EXPORTS: CmsConfigError, RequestFailed, GraphqlError, OfferNotFound, ZoneNotFound, LandingNotFound, ResortNotFound, PriceNotFound, PageNotFound

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__("XcBm");

// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/construct.js


function construct_construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    construct_construct = Reflect.construct.bind();
  } else {
    construct_construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) Object(setPrototypeOf["a" /* default */])(instance, Class.prototype);
      return instance;
    };
  }
  return construct_construct.apply(null, arguments);
}
// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js




function wrapNativeSuper_wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  wrapNativeSuper_wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return construct_construct(Class, arguments, Object(getPrototypeOf["a" /* default */])(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return Object(setPrototypeOf["a" /* default */])(Wrapper, Class);
  };
  return wrapNativeSuper_wrapNativeSuper(Class);
}
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/error.js/index.js
var error_js = __webpack_require__("x5Ag");
var error_js_default = /*#__PURE__*/__webpack_require__.n(error_js);

// CONCATENATED MODULE: ./src/errors/errors.js












function _createSuper(Derived) {
  var hasNativeReflectConstruct = errors_isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = Object(getPrototypeOf["a" /* default */])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return Object(possibleConstructorReturn["a" /* default */])(this, result);
  };
}

function errors_isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}


var NotFoundError = error_js_default.a.create({
  name: 'NotFoundError',
  message: 'Content not found',
  statusCode: 404,
  redirect: '/404',
  logLevel: 'warn'
});
var BadRequest = error_js_default.a.create({
  name: 'BadRequest',
  message: 'Bad request',
  statusCode: 400,
  logLevel: 'error'
});
var CmsConfigError = error_js_default.a.create({
  name: 'CmsConfigError',
  message: 'Cms configuration error',
  statusCode: 500,
  logLevel: 'error'
});
var RequestFailed = error_js_default.a.create({
  name: 'RequestFailed',
  message: 'Request failed',
  statusCode: 500,
  logLevel: 'error'
});
var GraphqlError = error_js_default.a.create({
  name: 'GraphqlError',
  message: 'Graphql request failed',
  statusCode: 500,
  logLevel: 'error'
});
var ClientSideError = error_js_default.a.create({
  name: 'ClientSideError',
  message: 'Client side error',
  statusCode: 500,
  logLevel: 'error'
});
var OfferNotFound = error_js_default.a.create({
  name: 'OfferNotFound'
}, NotFoundError);
var ZoneNotFound = error_js_default.a.create({
  name: 'ZoneNotFound'
}, NotFoundError);
var LandingNotFound = error_js_default.a.create({
  name: 'LandingNotFound'
}, NotFoundError);
var ResortNotFound = error_js_default.a.create({
  name: 'ResortNotFound'
}, NotFoundError);
var PriceNotFound = error_js_default.a.create({
  name: 'PriceNotFound'
}, NotFoundError);
var ProposalNotFound = error_js_default.a.create({
  name: 'ProposalNotFound'
}, NotFoundError);
var PageNotFound = error_js_default.a.create({
  name: 'PageNotFound'
}, NotFoundError);
var errors_ApiException = /*#__PURE__*/function (_Error) {
  Object(inherits["a" /* default */])(ApiException, _Error);

  var _super = _createSuper(ApiException);

  function ApiException(errors) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ApiException);

    _this = _super.call.apply(_super, [this].concat(Object(toConsumableArray["a" /* default */])(errors)));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "apiErrors", void 0);

    _this.name = 'ApiException';
    _this.apiErrors = errors;
    return _this;
  }

  return ApiException;
}( /*#__PURE__*/wrapNativeSuper_wrapNativeSuper(Error));

/***/ }),

/***/ "ybtA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Line", function() { return Line; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _logger_logger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("zytj");
/* harmony import */ var _context_ErrorBoundary__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("oG87");
/* harmony import */ var _cms_toolkit_descriptors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("nZ6J");





var __jsx = react__WEBPACK_IMPORTED_MODULE_5___default.a.createElement;




var Line = function Line(_ref) {
  var dataTestIdPrefix = _ref.dataTestIdPrefix,
      id = _ref.id,
      name = _ref.name,
      component = _ref.component,
      _ref$pageLines = _ref.pageLines,
      pageLines = _ref$pageLines === void 0 ? [] : _ref$pageLines,
      _ref$props = _ref.props,
      _ref$props$lines = _ref$props.lines,
      lines = _ref$props$lines === void 0 ? [] : _ref$props$lines,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(_ref$props, ["lines"]);

  if (!component && !Object(_cms_toolkit_descriptors__WEBPACK_IMPORTED_MODULE_8__[/* hasComponent */ "b"])(name) && lines.length === 0) {
    _logger_logger__WEBPACK_IMPORTED_MODULE_6__["default"].warn("Line without Component ".concat(String(id), " / ").concat(String(name)));
    return null;
  }

  var Component = component || Object(_cms_toolkit_descriptors__WEBPACK_IMPORTED_MODULE_8__[/* getComponent */ "a"])(name);

  if (Component) {
    return __jsx(_context_ErrorBoundary__WEBPACK_IMPORTED_MODULE_7__[/* ErrorBoundary */ "a"], {
      key: id
    }, __jsx(Component, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, props, {
      dataTestIdPrefix: dataTestIdPrefix,
      lines: lines,
      pageLines: pageLines
    }), lines.map(function (line) {
      return __jsx(Line, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, line, {
        dataTestIdPrefix: dataTestIdPrefix,
        key: line.id,
        pageLines: pageLines
      }));
    })));
  }

  return __jsx(_context_ErrorBoundary__WEBPACK_IMPORTED_MODULE_7__[/* ErrorBoundary */ "a"], {
    key: id
  }, lines.map(function (line) {
    return __jsx(Line, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, line, {
      dataTestIdPrefix: dataTestIdPrefix,
      key: line.id,
      pageLines: pageLines
    }));
  }));
};

/***/ })

}]);